/* --- CUSTOM HIRE DISCOUNT LOGIC V5 (IMMEDIATE EXECUTION) --- */

if (window.location.pathname.includes('/cart')) {
  
  // --- Configuration ---
  const PRODUCT_TYPE_TO_CHECK = 'Dress';
  const DISCOUNT_CODE = 'BACKUP';
  const DELIVERY_DATE_PROPERTY = 'Delivery Date';
  const RETURN_DATE_PROPERTY = 'Return Date';

  async function checkHireDiscount() {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('discount[code]') === DISCOUNT_CODE) {
      window.history.replaceState(null, '', window.location.pathname);
      return;
    }
    
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      const isDiscountApplied = cart.discount_codes.some(d => d.code === DISCOUNT_CODE);
      const hireItems = cart.items.filter(item => item.product_type === PRODUCT_TYPE_TO_CHECK);

      if (hireItems.length < 2) {
        if (isDiscountApplied) removeDiscount();
        return;
      }

      const itemsByDate = {};
      hireItems.forEach(item => {
        const deliveryDate = item.properties[DELIVERY_DATE_PROPERTY];
        const returnDate = item.properties[RETURN_DATE_PROPERTY];
        if (deliveryDate && returnDate) {
          const dateKey = `${deliveryDate}_${returnDate}`;
          if (!itemsByDate[dateKey]) itemsByDate[dateKey] = [];
          itemsByDate[dateKey].push(item);
        }
      });

      let shouldApplyDiscount = false;
      for (const dateKey in itemsByDate) {
        if (itemsByDate[dateKey].length >= 2) {
          shouldApplyDiscount = true;
          break;
        }
      }
      
      if (shouldApplyDiscount) {
        if (!isDiscountApplied) applyDiscount();
      } else {
        if (isDiscountApplied) removeDiscount();
      }
    } catch (error) {
      console.error('Error in hire discount script:', error);
    }
  }
  
  function applyDiscount() { window.location.href = `/checkout?discount=${DISCOUNT_CODE}`; }
  function removeDiscount() { window.location.href = `/cart?discount[code]=${DISCOUNT_CODE}&discount[remove]=true`; }

  checkHireDiscount();
}